import { render } from "./Modal.vue?vue&type=template&id=72ae246e&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-72ae246e"

export default script